/**
 * PDF 답안지 생성 관련 타입 정의
 */

import type { AnswerType, Problem } from './workbook';

/**
 * PDF 생성 옵션
 */
export interface GeneratePdfOptions {
  /** 문제집 이름 */
  workbookName: string;
  /** 페이지 번호 */
  page: number;
  /** 해당 페이지의 문제 목록 */
  problems: Problem[];
  /** 학생 이름 입력란 포함 여부 (기본값: true) */
  includeStudentName?: boolean;
  /** 날짜 입력란 포함 여부 (기본값: true) */
  includeDate?: boolean;
}

/**
 * 문제 박스 그리기 옵션
 */
export interface ProblemBoxOptions {
  /** X 좌표 (mm) */
  x: number;
  /** Y 좌표 (mm) */
  y: number;
  /** 박스 너비 (mm) */
  width: number;
  /** 박스 높이 (mm) */
  height: number;
  /** 문제 번호 */
  problemNumber: number;
  /** 답형식 */
  answerType: AnswerType;
  /** 답작성요령 (있으면 표시) */
  reference?: string;
}

/**
 * 답형식별 한글 이름
 */
export const ANSWER_TYPE_NAMES: Record<AnswerType, string> = {
  M: '객관식',
  S: '보기선택',
  B: 'OX',
  N: '숫자',
  E: '수식',
  F: '수식',
  I: '인수분해',
  T: '서술형',
  H: '한글서술',
};

/**
 * 답형식별 입력 가이드
 */
export const ANSWER_TYPE_GUIDES: Record<AnswerType, string> = {
  M: '① ② ③ ④ ⑤ 중 선택',
  S: 'ㄱ,ㄴ,ㄷ,ㄹ,ㅁ 중 선택',
  B: 'O 또는 X',
  N: '숫자 입력',
  E: '수식 작성',
  F: '수식 작성',
  I: '인수분해 형태로 작성',
  T: '서술형 답안',
  H: '서술형 답안',
};
